<template>
    <svg width="90" height="41" viewBox="0 0 90 41" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path opacity="0.2" fill-rule="evenodd" clip-rule="evenodd" d="M59.1606 25.1758H5.29695C2.37153 25.1758 0 22.8043 0 19.8789C0 16.9535 2.37153 14.5819 5.29695 14.5819H59.1606V1.97344C59.1606 0.38356 61.0008 -0.551432 62.3467 0.354605L89.1276 18.383C90.2915 19.1665 90.2915 20.8372 89.1276 21.6207L62.3467 39.6491C61.0008 40.5551 59.1606 39.6201 59.1606 38.0303V25.1758Z" fill="#0764E9"/>
    </svg>
</template>
